// 벌크 등록 표에 붙여넣은 텍스트(엑셀 복사·CSV) -> 행 값. 화면 상태와 무관한 순수 함수 (tests/vendor-code-paste-rows.test.cjs)

// 헤더 칸으로 인정하는 이름 (소문자, 공백 제거) — 양식 영문 헤더 + 표의 한글 머리글
const HEADER_NAMES = ['company_id', 'company_name', 'vendor_code', 'project_code', '회사id', '회사명', '업체id', '업체명', '벤더코드'];

// 3열 이상(fixed)이면 (회사 ID, 회사명, 벤더코드) 자리 그대로 — 회사 ID 칸이 비어도 회사명이 벤더코드 칸으로 밀리지 않는다.
// 2열이면 첫 칸이 숫자일 때만 회사 ID 로 보고, 아니면 (회사명, 벤더코드) 로 본다. 모두 비면 null.
function coerceCells(c1, c2, c3, fixed = false) {
    const [a, b, c] = [c1, c2, c3].map(v => (v == null ? '' : String(v).trim()));
    if (!a && !b && !c) return null;
    if (fixed || /^\d+$/.test(a)) return { company_id: a, company_name: b, vendor_code: c };
    return { company_id: '', company_name: a, vendor_code: b };
}

function parsePastedRows(text) {
    const lines = String(text || '').replace(/\r\n?/g, '\n').split('\n').filter(l => l.length > 0);
    if (lines.length === 0) return [];

    // 탭 우선, 없으면 콤마
    const parsed = lines.map(line => line.split(line.includes('\t') ? '\t' : ',').map(c => c.trim()));

    // 첫 줄에 헤더 이름과 똑같은 칸이 있으면 헤더로 보고 스킵한다.
    // ('회사'가 들어갔는지로 보면 '주식회사 …' 같은 첫 데이터 행이 헤더로 버려진다)
    const header = parsed[0].map(c => c.toLowerCase());
    const hasHeader = header.some(c => HEADER_NAMES.includes(c.replace(/\s/g, '')));
    const dataRows = hasHeader ? parsed.slice(1) : parsed;
    // 영문 헤더 3개가 다 있으면 헤더 위치대로 읽는다 (열 순서가 달라도 됨)
    const idx = ['company_id', 'company_name', 'vendor_code'].map(k => header.indexOf(k));
    const byHeader = hasHeader && idx.every(i => i >= 0);

    return dataRows
        .map(cols => (byHeader
            ? coerceCells(cols[idx[0]], cols[idx[1]], cols[idx[2]], true)
            : coerceCells(cols[0], cols[1], cols[2], cols.length >= 3)))
        .filter(Boolean);
}

// 테스트(node --test)가 require 로 읽으므로 CommonJS 로 내보낸다 (errorMessage.js 와 같은 관례).
module.exports = { coerceCells, parsePastedRows };
